import type { Translation } from 'store/slices/general/general.slice';

const CONSTANTS_TRANSLATIONS = {
  PER_DAY: {
    en: 'd',
    fr: 'j',
  },
};
export const translate = (
  translations: Array<Translation>,
  key: string,
  language = 'en',
): string => {
  if (key in CONSTANTS_TRANSLATIONS) {
    // @ts-ignore
    return CONSTANTS_TRANSLATIONS[key][language];
  }
  const parsedTranslations = translations.find(
    (item) => item.translationKey === key,
  );
  return (
    parsedTranslations?.[language as keyof typeof parsedTranslations] || ''
  );
};
